import script from "./ItemIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemIcon.vue?vue&type=script&setup=true&lang=js"

import "./ItemIcon.vue?vue&type=style&index=0&id=33109916&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33109916"]])

export default __exports__